import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView,CrudMasterDetailViewPaginated, GridView, CrudContext, CompositeView, usePromise } from '@digital/ui';
import * as ContratoBaseApi from '@app/api/contrato/contratoBase';
import AbaGeral, { initialValuesAbaGeral } from './geral';
import AbaInfoComplementar from './infoComplementar';
import AbaAditivos from './aditivos';
import AbaSegurosGarantias from './segurosGarantias';
import AbaResumoMedicoes from './resumoMedicoes';
import AbaEncerramento from './encerramento';
import AbaPlanilhaQuantidadeContrato from './planilhaPq';
import AbaDocumentacaoAcessoria from './documentacaoAcessoria';
import { AbaGeralContrato, getAbaGeralById } from '@app/api/contrato/geral';
import AbaCorrespondencias from './correspondencias';
import { hasPermission } from '@app/helpers/permissions';
import './custom.css';
import { AbaBmTotvs } from '..';
import { Contrato as ContratoInterface } from '@app/api/contrato/contratoBase';
import { compareStringSlug } from '@app/helpers/stringHelper';
import { Visibility } from '@app/components/Visibility';
import { AbaResumoMedicaoCMG } from './resumoMedicoes/multiploGestor/AbaResumoMedicaoCMG';
import { AbaSubcontratacoes } from './subcontratacoes';

const Contrato = () => {
  const [itemSelecionado, setItemSelecionado] = useState<ContratoInterface>();
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [dadosGerais, setDadosGerais] = useState<AbaGeralContrato>();
  const [isConsolidado, setIsConsolidado] = useState(false);
  const [updateDadosGerais, setUpdateDadosGerais] = useState(false)

  const onUpdateDadosGerais = () => {
    setUpdateDadosGerais(!updateDadosGerais)
  }

  const [GetAllItems, setGetAllItems] = useState(() => {
    return ContratoBaseApi.getAllContratos;
  });

  const handleUpdate = () => {
    setGetAllItems(() => () => Promise.resolve(undefined));
    setGetAllItems(() => ContratoBaseApi.getAllContratos);
  };

  useMemo(async () => {
    const itens = await ContratoBaseApi.getAllContratos();
    if (itens) {
      setGetAllItems(() => () => Promise.resolve(undefined));
      setGetAllItems(() => () => Promise.resolve(itens));
    }
  }, [atualizarTela]);

  const AtualizarItemTela = () => {
    setAtualizarTela(!atualizarTela);
  };

  useMemo(async () => {
    if (itemSelecionado) {
      const result = await getAbaGeralById(itemSelecionado.id);
      if (result) {
        setDadosGerais(result);
      }
    }
  }, [itemSelecionado, updateDadosGerais]);

  return (
    <CrudMasterDetailViewPaginated
      pageSize={100}
      getAllItems={GetAllItems}
      filterPredicate={(item, value) =>
        compareStringSlug(item.fornecedor, value)
        || compareStringSlug(item.numero.toString(), value)
        || compareStringSlug(item.status, value)
        || (
          item.situacao
            ? compareStringSlug('vigente', value)
            : compareStringSlug(item.situacaoVencimento, value)
        )
        || compareStringSlug(item.objetoResumido, value)
      }
      titleExtractor={item =>
        item.numero.toString() +
        ' - ' +
        item.status + ' - ' +
        (item.situacao ?
          ((item.statusEncerramentoCodigo != 1 && item.statusEncerramentoCodigo != 9) ?
            'Vigente em Encerramento' : 'Vigente') : item.situacaoVencimento)
      }
      detailTitleExtractor={item =>
        item.numero +
        ' - ' +
        item.fornecedor +
        ' - ' +
        item.status +
        ' - ' +
        (item.situacao ? ((item.statusEncerramentoCodigo != 1 && item.statusEncerramentoCodigo != 9) ? 'Vigente em Encerramento' : 'Vigente') : item.situacaoVencimento)
      }
      descriptionExtractor={item => item.fornecedor || '---'}>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          {
            setItemSelecionado(selectedItem as ContratoInterface);
            setIsConsolidado(selectedItem && selectedItem.isConsolidado);
          }
          return (
            <CompositeView>
              {hasPermission(['CONTRATO_GERAL_VISUALIZAR_ABA']) ? (
                <GridView icon="commons-document" id="geral" noform title="GERAL">
                  <AbaGeral onUpdate={AtualizarItemTela} geralData={dadosGerais} />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_INF_COMPLEMENTAR_VISUALIZAR_ABA']) ? (
                <GridView icon="files-view_file" title="INF.COMPLEMENTARES" noform id="infoComplementar">
                  <AbaInfoComplementar
                    onUpdate={handleUpdate}
                    isMultiplosGestores={selectedItem && selectedItem.isMultiplosGestores}
                    isConsolidado={isConsolidado}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_PQ_VISUALIZAR_ABA']) ? (
                <GridView icon="data-data_sheet" noform title="PQ" id="planilhaQuantidade">
                  <AbaPlanilhaQuantidadeContrato
                    isDefined={selectedItem && selectedItem.isDefined}
                    isMultiplosGestores={selectedItem && selectedItem.isMultiplosGestores}
                    isConsolidado={isConsolidado}
                    setIsConsolidado={setIsConsolidado}
                    onUpdate={handleUpdate}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_BM_TOTVS_VISUALIZAR_ABA']) && selectedItem ? (
                <GridView icon="programming-important_property" noform title="BM TOTVS" id="bmTotvs">
                  <AbaBmTotvs contratoId={selectedItem.id} isMultiplosGestores={selectedItem.isMultiplosGestores} />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_ADITIVO_VISUALIZAR_ABA']) ? (
                <GridView icon="files-add_file" title="ADITIVOS" noform>
                  <AbaAditivos />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_DOC_ACESSORIA_VISUALIZAR_ABA']) &&
                selectedItem &&
                selectedItem.dataHoraPrimeiraAtivacao != null &&
                (selectedItem.possuiDocumentacaoAcessoria || selectedItem.possuiDocumentacaoAcessoriaMensalCadastrada) ? (
                <GridView icon="files-versions" id="documentacaoAcessoria" noform title="DOC. ACESSÓRIA">
                  <AbaDocumentacaoAcessoria
                    gerirDocumentacaoAcessoria={selectedItem.gerirDocumentacaoAcessoria}
                    urlAcessoDocumentacasoAcessorial={selectedItem.urlAcessoDocumentacasoAcessorial}
                  />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_SEGURO_GARANTIA_VISUALIZAR_ABA']) &&
                selectedItem &&
                selectedItem.dataHoraPrimeiraAtivacao != null &&
                (selectedItem.possuiSegurosGarantias || selectedItem.possuiDocumentoSeguroGarantiaCadastrado) ? (
                <GridView icon="security-security_checked" id="seguroGarantia" noform title="SEGUROS E GARANTIAS">
                  <AbaSegurosGarantias />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_RESUMO_MEDICOES_VISUALIZAR_ABA']) &&
                selectedItem &&
                selectedItem.dataHoraPrimeiraAtivacao != null &&
                selectedItem.id ? (
                <GridView icon="printing-ruler" title="RESUMO MEDIÇÕES" noform id="resumoMedicao">

                  <Visibility visible={selectedItem && !selectedItem.isMultiplosGestores}>
                    <AbaResumoMedicoes contratoId={selectedItem.id} />
                  </Visibility>

                  <Visibility visible={selectedItem && selectedItem.isMultiplosGestores}>
                    <AbaResumoMedicaoCMG contratoId={selectedItem.id} />
                  </Visibility>

                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_SUBCONTRATACOES_VISUALIZAR_ABA']) &&
                selectedItem &&
                selectedItem.id 
                && selectedItem.deveExibirAbaSubContratacao ? (
                <GridView icon='business-contract_job' title='SUBCONTRATAÇÕES' noform id='subcontratacoes'>{
                }<AbaSubcontratacoes
                    contratoId={selectedItem.id}
                    dadosGerais={dadosGerais}
                    onUpdateDadosGerais={onUpdateDadosGerais}
                    onUpdateContratos={handleUpdate}
                  />
                </GridView>
              ) : (
                () => { }
              )
              }
              {hasPermission(['CONTRATO_CORRESPONDENCIA_VISUALIZAR_ABA']) ? (
                <GridView icon="messaging-message" id="correspondencias" noform title="CORRESPONDÊNCIAS">
                  <AbaCorrespondencias />
                </GridView>
              ) : (
                () => { }
              )}
              {hasPermission(['CONTRATO_ENCERRAMENTO_VISUALIZAR_ABA']) ? (
                <GridView icon="files-check_file_filled2" id="encerramento" noform title="ENCERRAMENTO">
                  <AbaEncerramento />
                </GridView>
              ) : (
                () => { }
              )}
            </CompositeView>
          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default Contrato;
